import { render, staticRenderFns } from "./MissionRankingTableItemParts.vue?vue&type=template&id=3c06552c&scoped=true"
import script from "./MissionRankingTableItemParts.vue?vue&type=script&lang=ts"
export * from "./MissionRankingTableItemParts.vue?vue&type=script&lang=ts"
import style0 from "./MissionRankingTableItemParts.vue?vue&type=style&index=0&id=3c06552c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c06552c",
  null
  
)

export default component.exports